<template>
  <div
    class="fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center"
  >
    <div class="text-center">
      <svg
        class="animate-spin h-12 w-12 text-green-600 mx-auto"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        />
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      <p class="mt-4 text-lg text-gray-600">Loading...</p>
    </div>
  </div>
</template>

<script setup>
// The component is currently a static loading screen with no reactive behavior
</script>
